<template>
  <div class="leaderboard">

    <div class="lb-header">
      <div class="lb-header-left">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#00b4b4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M2 19h20M3 9l4 4 5-7 5 7 4-4v10H3z"/>
        </svg>
        <h2>FreeSpan Opportunities Leaderboard</h2>
      </div>
      <a href="/freespan-opportunity-registration" class="submit-btn">
        Submit Opportunity <i class="material-icons">keyboard_arrow_right</i>
      </a>
    </div>

    <div v-if="loading" class="loading">
      <AtomSpinner :animation-duration="1000" :size="60" color="#00b4b4" />
    </div>

    <div v-else class="places-row">

      <!-- 1st Place -->
      <div v-if="leaderboard?.firstPlace?.length" class="place">
        <div class="watermark">1</div>
        <div class="place-header">
          <div class="dot dot-gold"></div>
          <span class="place-rank">1st place</span>
          <span class="place-subs">{{ leaderboard.firstPlace[0].SubmissionCount }} submissions</span>
        </div>
        <hr class="hr"/>
        <div v-for="(entry, index) in leaderboard.firstPlace" :key="index" class="entry">
<p class="entry-name">
  {{ entry.SalesRep }} - 
  <span class="entry-co" :title="entry.AreaContractorName">
    {{ formatCompanyName(entry.AreaContractorName) }}
  </span>
</p>          
        </div>
      </div>

      <!-- 2nd Place -->
      <div v-if="leaderboard?.secondPlace?.length" class="place">
        <div class="watermark">2</div>
        <div class="place-header">
          <div class="dot dot-silver"></div>
          <span class="place-rank">2nd place</span>
          <span class="place-subs">{{ leaderboard.secondPlace[0].SubmissionCount }} submissions</span>
        </div>
        <hr class="hr"/>
        <div v-for="(entry, index) in leaderboard.secondPlace" :key="index" class="entry">
<p class="entry-name">
  {{ entry.SalesRep }} - 
  <span class="entry-co" :title="entry.AreaContractorName">
    {{ formatCompanyName(entry.AreaContractorName) }}
  </span>
</p>
        </div>
      </div>

      <!-- 3rd Place -->
      <div v-if="leaderboard?.thirdPlace?.length" class="place">
        <div class="watermark">3</div>
        <div class="place-header">
          <div class="dot dot-bronze"></div>
          <span class="place-rank">3rd place</span>
          <span class="place-subs">{{ leaderboard.thirdPlace[0].SubmissionCount }} submissions</span>
        </div>
        <hr class="hr"/>
        <div v-for="(entry, index) in leaderboard.thirdPlace" :key="index" class="entry">
<p class="entry-name">
  {{ entry.SalesRep }} - 
  <span class="entry-co" :title="entry.AreaContractorName">
    {{ formatCompanyName(entry.AreaContractorName) }}
  </span>
</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";




export default {
  name: 'FreespanLeaderboard',
  components: { AtomSpinner },
  data() {
    return {
      server: import.meta.env.VITE_APP_SERVER_URL,
      // server: 'http://localhost:5002',
      loading: true,
      rawSubmissions: [],
      leaderboard: null
    };
  },
  created() {
    this.fetchLeaderboard();
  },
  methods: {
    async fetchLeaderboard() {
      const auth = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("USER"),
        },
      };
      try {
        const response = await axios.get(`${this.server}/api/v1/freespan-stats`, auth);
        this.rawSubmissions = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    formatCompanyName(name) {
    if (!name) return '';
    
    return name
      .toLowerCase()                    // first make everything lowercase
      .split(/\s+/)                     // split on any whitespace
      .map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');                       // join back with single space
  },
    createLeaderboard(data) {
      if (!Array.isArray(data) || data.length === 0) {
        return { firstPlace: [], secondPlace: [], thirdPlace: [] };
      }
      const sorted = [...data].sort((a, b) => b.SubmissionCount - a.SubmissionCount);
      const result = { firstPlace: [], secondPlace: [], thirdPlace: [] };
      let currentRank = 1;
      let i = 0;
      while (i < sorted.length && currentRank <= 3) {
        const currentCount = sorted[i].SubmissionCount;
        const group = [];
        while (i < sorted.length && sorted[i].SubmissionCount === currentCount) {
          group.push({
            SalesRep: sorted[i].SalesRep,
            AreaContractorName: sorted[i].AreaContractorName,
            SubmissionCount: sorted[i].SubmissionCount
          });
          i++;
        }
        if (currentRank === 1) result.firstPlace = group;
        else if (currentRank === 2) result.secondPlace = group;
        else if (currentRank === 3) result.thirdPlace = group;
        currentRank++;
      }
      return result;
    }
  },
  watch: {
    rawSubmissions: {
      handler(newData) {
        this.leaderboard = this.createLeaderboard(newData);
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.leaderboard {
  max-width: 1200px;
  margin: 20px 0;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

/* Header */
.lb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px;
}

.lb-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lb-header-left h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #111;
}

.submit-btn {
  font-size: 12px;
  color: #00b4b4;
  border: 1px solid #00b4b4;
  border-radius: 4px;
  padding: 5px 12px;
  display: flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.25s ease;   
}

.submit-btn:hover {
  background: #00b4b4;
  color: #fff;
}

/* Loading */
.loading {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

/* Places row */
.places-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 0 16px 20px;
}

/* Each place card */
.place {
  position: relative;
  overflow: hidden;
  /*border: 1px solid #f0f0f0;*/
  border-radius: 8px;
  padding: 16px 18px;
  background: #fff;
  /*
  background: linear-gradient(180deg, #f5f7f7, #ffffff);
  */
  /*background: linear-gradient(180deg, #ffffff, #fafafa);*/

  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
  border-top: 4px solid rgb(179 182 185 / 20%);
}

/* Large faint watermark number */
.watermark {
  position: absolute;
  right: -4px;
  top: -8px;
  font-size: 80px;
  font-weight: 700;
  line-height: 1;
  color: #dedede;
  pointer-events: none;
  user-select: none;
  opacity: 0;
}

/* Place header: dot + rank + subs */
.place-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dot-gold   { background: #00b4b4; }
.dot-silver { background: #5c6d7e; }
.dot-bronze { background: #4d5967; }

.place-rank {
  font-size: 18px;
  font-weight: 500;
  color: #6c757d!important
}

.place-subs {
  font-size: 13px;
  color: #6c757d!important;
  margin-left: auto;
}

/* Entries */
.entry {
  padding: 5px 0;
}

.entry-name {
  font-size: 13px;
  font-weight: 500;
  color: #111;
  margin: 0 0 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;           /* keeps everything on one line */
  overflow: hidden;              /* hides overflow */
  text-overflow: ellipsis;       /* shows ... when truncated */
  max-width: 100%;               /* or set a fixed max-width like 280px if needed */
  display: block;
}

.entry-co {
  font-size: 13px;
  color: #6c757d!important;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Responsive */
@media (max-width: 720px) {
  .places-row {
    grid-template-columns: 1fr;
  }
}
.hr{
    margin-top: 5px;
    margin-bottom: 5px;
}
</style>